import { inject, Injectable, Injector } from '@angular/core';

import { IconsContainerStrategy } from './contracts';
import { IconsContainerService } from './icons-container.service';
import { allIcons } from '../../icons/all-icons';
import type { IconName } from '../common/icon/icons.type';

@Injectable({ providedIn: 'root' })
export class IconsContainerBundledStrategy implements IconsContainerStrategy {
  private readonly iconsContainerService = inject(IconsContainerService);

  public async load(name: IconName, iconEl: HTMLElement, injector: Injector) {
    if (!name) return console.warn('IconsContainerBundledStrategy: No icon name provided');

    const { instance } = await this.iconsContainerService.getContainer(iconEl, injector);
    if (instance.hasVisibleIcon(name)) return;

    instance.updateVisibleIcons(name, allIcons[name]);
  }
}
